import React from 'react';
import { FaWallet, FaExclamationTriangle, FaHandHoldingUsd } from 'react-icons/fa';

export default function TotalSummary({ customers = [] }) {
  const totalAmount = customers.reduce((acc, c) => acc + parseFloat(c.price || 0), 0);
  const totalDue = customers.reduce((acc, c) => acc + parseFloat(c.due_amount || 0), 0);
  const totalReceived = totalAmount - totalDue;

  return (
    <div className="mt-3 flex flex-col md:flex-row gap-4">
      <div className="flex-1 bg-green-100 rounded-lg p-4 text-center font-semibold shadow">
        <h5 className="flex items-center justify-center gap-2 text-green-700 mb-2 text-lg">
          <FaWallet /> Total Amount
        </h5>
        <h3 className="text-green-800 text-3xl">₹{totalAmount.toFixed(2)}</h3>
      </div>
      <div className="flex-1 bg-red-100 rounded-lg p-4 text-center font-semibold shadow">
        <h5 className="flex items-center justify-center gap-2 text-red-700 mb-2 text-lg">
          <FaExclamationTriangle /> Due Amount
        </h5>
        <h3 className="text-red-800 text-3xl">₹{totalDue.toFixed(2)}</h3>
      </div>
      <div className="flex-1 bg-blue-100 rounded-lg p-4 text-center font-semibold shadow">
        <h5 className="flex items-center justify-center gap-2 text-blue-700 mb-2 text-lg">
          <FaHandHoldingUsd /> Received
        </h5>
        <h3 className="text-blue-800 text-3xl">₹{totalReceived.toFixed(2)}</h3>
      </div>
    </div>
  );
}

